/*
 *
 * Login Modal
 *
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectResults as getLoginType } from '../../services/LoginType/selectors';
import LegacyLogin from './LegacyLogin';
import LoginTypeForm from './LoginTypeForm';
import OktaForm from './OktaForm';
import { makeRequest as ssoLogin } from '../../services/SsoLogin';

function Login(props) {
  const { oktaWidget } = props;
  const { loginType } = props.loginTypeResults || {};
  const [username, setUsername] = useState('');

  useEffect(() => {
    function handleTokenResponse(res) {
      const params = {
        idToken: res.tokens.idToken.idToken,
        accessToken: res.tokens.accessToken.accessToken,
      };
      props.ssoLoginRequest(params);
    }
    if (oktaWidget.hasTokensInUrl()) {
      oktaWidget.authClient.token
        .parseFromUrl()
        .then((res) => {
          handleTokenResponse(res);
        })
        .catch((err) => console.error(err)); // eslint-disable-line no-console
    } else {
      oktaWidget.authClient.token
        .getWithoutPrompt({ scopes: ['openid', 'email', 'profile'] })
        .then((res) => {
          handleTokenResponse(res);
        })
        .catch((err) => console.error(err)); // eslint-disable-line no-console
    }
  }, []);

  if (!loginType) return <LoginTypeForm onUsernameUpdate={(value) => setUsername(value)} />;
  if (loginType === 'LEGACY') return <LegacyLogin username={username} />;
  if (loginType === 'OKTA') return <OktaForm username={username} />;

}

Login.defaultProps = {
  loginTypeResults: {},
};

Login.propTypes = {
  loginTypeResults: PropTypes.object,
  oktaWidget: PropTypes.object.isRequired, // OktaWidget instantiated in App.js
};

const mapStateToProps = (state) => ({
  loginTypeResults: getLoginType(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    ssoLoginRequest: (params) => dispatch(ssoLogin(params)),
  },
  dispatch
);

export { NAMESPACE, LEGIT_SERVICE_CONFIG } from './constants';
export { default as reducer } from './reducer';
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js